module.exports = [{
    text: "Default",
    value: "Default",
},{
    text: "Latin alphabet No. 1 [ISO_IR 100]",
    value: "Latin1",
},{
    text: "Latin alphabet No. 2 [ISO_IR 101]",
    value: "Latin2",
},{
    text: "Latin alphabet No. 3 [ISO_IR 109]",
    value: "Latin3",
},{
    text: "Latin alphabet No. 4 [ISO_IR 110]",
    value: "Latin4",
},{
    text: "Cyrillic [ISO_IR 144]",
    value: "Cyrillic",
},{
    text: "Arabic [ISO_IR 127]",
    value: "Arabic",
},{
    text: "Greek [ISO_IR 126]",
    value: "Greek",
},{
    text: "Hebrew [ISO_IR 138]",
    value: "Hebrew",
},{
    text: "Latin alphabet No. 5 [ISO_IR 148]",
    value: "Latin5",
},{
    text: "Japanese JIS: Katakana and Romanji [ISO_IR 13]",
    value: "Japanese",
},{
    text: "Thai [ISO_IR 166]",
    value: "Thai",
},{
    text: "Unicode UTF-8 [ISO_IR 192]",
    value: "Utf8",
},{
    text: "Chinese GB18030 [GB18030]",
    value: "Chinese",
}];
